import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { userId } from '../../../reducers/currentUser/currentUser.reducer';
import { loadForForeman } from '../../../reducers/workOrder/workOrders.actions';
import { loading, approvedWorkOrders, submittedWorkOrders } from '../../../reducers/workOrder/workOrders.reducer';
import { Spinner } from '../../Spinner/Spinner';
import WorkOrderList from '../../WorkOrderList/WorkOrderList';
import './ForemanHistory.css';

// eslint-disable-next-line object-curly-newline
export class ForemanHistory extends React.Component {
  componentDidMount() {
    this.props.load(this.props.id);
  }

  render() {
    return (
      <span>
        <LinkContainer to="/foreman/workorders/new" >
          <Button className="pull-right" bsStyle="primary" >Create New DWR</Button>
        </LinkContainer>
        <br />
        {this.props.loading && <Spinner isLoading /> }
        {this.props.submittedWorkOrders.length > 0 && <WorkOrderList workOrders={this.props.submittedWorkOrders} url="/foreman" /> }
        {this.props.approvedWorkOrders.length > 0 && <WorkOrderList workOrders={this.props.approvedWorkOrders} url="/foreman" /> }
      </span>
    );
  }
}

ForemanHistory.propTypes = {
  load: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  approvedWorkOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  submittedWorkOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  approvedWorkOrders: submittedWorkOrders(state),
  submittedWorkOrders: approvedWorkOrders(state),
  loading: loading(state),
  id: userId(state),
});

export const mapDispatchToProps = dispatch => ({
  load: id => dispatch(loadForForeman(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForemanHistory);



// WEBPACK FOOTER //
// ./src/components/Foreman/History/ForemanHistory.jsx